import React from 'react'
import ReactDOM from 'react-dom'

// Fonts
import './index.css'
import './fonts/adellesans-bold-webfont.ttf'
import './fonts/adellesans-regular-webfont.ttf'

// serviceWorker
import * as serviceWorker from './serviceWorker'

// internationalization
import './i18n'

import ReduxApp from './components/ReduxApp'
ReactDOM.render(<ReduxApp />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
